export default __webpack_public_path__ + "static/media/img-multi-sig-wallet-new.a802b6bb.jpg";